import AffiliateModal from '@features/games/profile/affiliate/affiliate';
export default AffiliateModal;
